import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isMobile } from 'src/app/controls/functions/shared-functions';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<ConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    if (isMobile()) {
      this.dialogRef.updateSize('auto', 'auto');
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }
  continue() {
    this.dialogRef.close(this.data || 1);
  }
}
